import api from './api';

const fileStatusService = {
  // Get workflow information
  getWorkflow: async () => {
    try {
      const response = await api.get('/mrd/file-status/workflow');
      return response.data;
    } catch (error) {
      console.error('Error fetching workflow:', error);
      throw error;
    }
  },

  // Get allowed actions for a file
  getFileActions: async (fileId) => {
    try {
      const response = await api.get(`/mrd/file-status/${fileId}/actions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching file actions:', error);
      throw error;
    }
  },

  // Update file status manually (admin only)
  updateFileStatus: async (fileId, newStatus, reason) => {
    try {
      const response = await api.put(`/mrd/file-status/${fileId}/status`, {
        newStatus,
        reason
      });
      return response.data;
    } catch (error) {
      console.error('Error updating file status:', error);
      throw error;
    }
  },

  // Get file status history
  getFileStatusHistory: async (fileId) => {
    try {
      const response = await api.get(`/mrd/file-status/${fileId}/history`);
      return response.data;
    } catch (error) {
      console.error('Error fetching file status history:', error);
      throw error;
    }
  },

  // Check if action is allowed for file status
  isActionAllowed: (fileStatus, action, userRole) => {
    const allowedActions = {
      'OPEN': ['VIEW', 'EDIT', 'ADD_DEFICIENCY', 'START_PROCESSING'],
      'IN_PROGRESS': ['VIEW', 'EDIT', 'ADD_DEFICIENCY', 'MEDICAL_CODING', 'COMPLETE'],
      'DEFICIENT': ['VIEW', 'CHECK_DEFICIENCIES', 'RESOLVE_DEFICIENCIES'],
      'COMPLETED': ['VIEW', 'CLOSE', 'ADD_DEFICIENCY'],
      'CLOSED': ['VIEW', 'ARCHIVE', 'REOPEN'],
      'ARCHIVED': ['VIEW', 'RETRIEVE']
    };

    return allowedActions[fileStatus]?.includes(action) || false;
  },

  // Get button visibility based on file status and user role
  getButtonVisibility: (fileStatus, userRole) => {
    console.log('getButtonVisibility called with:', { fileStatus, userRole });
    
    const buttons = {
      view: true, // Always visible
      edit: false,
      deficiencies: false,
      medicalCoding: false,
      close: false,
      archive: false,
      retrieve: false
    };
 console.log(userRole);
    // Admin users can see all buttons
   const isAdmin = userRole && userRole.toUpperCase() === 'ADMIN';

    // Temporary: Show buttons for testing (remove this in production)
    if (!userRole) {
      console.warn('No user role provided, showing default buttons');
      buttons.deficiencies = true;
      return buttons;
    }

    switch (fileStatus) {
      case 'OPEN':
        buttons.edit = isAdmin || ['MRD_INCHARGE', 'MRD_STAFF', 'ADMIN'].includes(userRole);
        buttons.deficiencies = true;
        buttons.medicalCoding = true;
        break;
      case 'DEFICIENT':
        buttons.deficiencies = true;
        buttons.medicalCoding = true;
        break;
      case 'COMPLETED':
        buttons.deficiencies = true;
        buttons.medicalCoding = true;
        buttons.close = isAdmin || ['MRD_STAFF', 'MRD_INCHARGE', 'ADMIN'].includes(userRole);
        break;
      case 'CLOSED':
        buttons.archive = isAdmin || ['MRD_INCHARGE', 'ARCHIVAL_STAFF', 'ADMIN'].includes(userRole);
        break;
      case 'ARCHIVED':
        buttons.retrieve = isAdmin || ['MRD_INCHARGE', 'ARCHIVAL_STAFF', 'ADMIN'].includes(userRole);
        break;
      default:
        console.warn('Unknown file status:', fileStatus);
        buttons.deficiencies = true;
        break;
    }

    console.log('Button visibility result:', buttons);
    return buttons;
  },

  // Get status color for UI
  getStatusColor: (status) => {
    const colors = {
      'OPEN': 'info',
      'IN_PROGRESS': 'warning',
      'DEFICIENT': 'error',
      'COMPLETED': 'success',
      'CLOSED': 'secondary',
      'ARCHIVED': 'default'
    };
    return colors[status] || 'default';
  },

  // Get status display name
  getStatusDisplayName: (status) => {
    const names = {
      'OPEN': 'Open',
      'IN_PROGRESS': 'In Progress',
      'DEFICIENT': 'Deficient',
      'COMPLETED': 'Completed',
      'CLOSED': 'Closed',
      'ARCHIVED': 'Archived'
    };
    return names[status] || status;
  },

  // Get next possible statuses
  getNextStatuses: (currentStatus) => {
    const transitions = {
      'OPEN': ['DEFICIENT'],
      'DEFICIENT': ['COMPLETED'],
      'COMPLETED': ['CLOSED'],
      'CLOSED': ['ARCHIVED'],
      'ARCHIVED': []
    };
    return transitions[currentStatus] || [];
  },

  // Check if status transition is allowed
  isTransitionAllowed: (currentStatus, newStatus) => {
    const nextStatuses = fileStatusService.getNextStatuses(currentStatus);
    return nextStatuses.includes(newStatus);
  }
};

export default fileStatusService;